import React from 'react';
import strings from 'strings';
import ProfileTableLayout from 'UI/components/organisms/inventoryProfiles/ProfileTableLayout';
import { TabKeys } from 'UI/constants/entityTypes';

const COPIES = strings.inventoryProfiles.emptyStates.sales;

export const SalesTab = ({
  DataTableProps = {},
  initialColumns,
  profileId,
  profileModule,
  ...rest
}) => {
  const { endpoint } = DataTableProps;
  const finalEndpoint = endpoint.replace(':id', profileId);

  return (
    <ProfileTableLayout
      actionText={strings.dailyPlan.actionButton}
      DataTableProps={{
        ...DataTableProps,
        endpoint: finalEndpoint
      }}
      hasProfileLoaded={!!profileId}
      initialColumns={initialColumns}
      isExpandable={false}
      profileModule={profileModule}
      search={false}
      tabKey={TabKeys.Sales}
      title={COPIES.title}
      {...rest}
    />
  );
};
